// src/components/ui/LuxuryButton.jsx - SIMPLIFIED VERSION
import { motion } from 'framer-motion';

export default function LuxuryButton({
                                       children,
                                       variant = 'primary',
                                       size = 'medium',
                                       icon,
                                       iconPosition = 'right',
                                       fullWidth = false,
                                       isLoading = false,
                                       ...props
                                     }) {
  const variants = {
    primary: 'bg-gradient-to-r from-champagne to-champagne/80 text-charcoal',
    secondary: 'bg-transparent border border-champagne/40 text-champagne',
    ghost: 'bg-transparent text-charcoal',
    dark: 'bg-charcoal text-pearl'
  };

  const sizes = {
    small: 'px-6 py-2 text-sm',
    medium: 'px-8 py-3 text-base',
    large: 'px-10 py-4 text-lg'
  };

  return (
      <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          className={`
        ${variants[variant]}
        ${sizes[size]}
        ${fullWidth ? 'w-full' : ''}
        font-medium tracking-wide rounded-full
        relative overflow-hidden
        transition-all duration-300
        hover:shadow-lg
        disabled:opacity-50 disabled:cursor-not-allowed
      `}
          disabled={isLoading}
          {...props}
      >
      <span className="relative flex items-center justify-center gap-2">
        {icon && iconPosition === 'left' && (
            <span className="group-hover:translate-x-[-2px] transition-transform">
            {icon}
          </span>
        )}

        {isLoading ? (
            <span className="flex items-center gap-2">
            <span className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin" />
            Loading...
          </span>
        ) : (
            children
        )}

        {icon && iconPosition === 'right' && (
            <span className="group-hover:translate-x-1 transition-transform">
            {icon}
          </span>
        )}
      </span>
      </motion.button>
  );
}